import { render, staticRenderFns } from "./FreeGiftLineItem.vue?vue&type=template&id=71a2f15b&"
import script from "./FreeGiftLineItem.vue?vue&type=script&lang=js&"
export * from "./FreeGiftLineItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jasonplumb/pixelcabin/themes/lavazza-expert/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71a2f15b')) {
      api.createRecord('71a2f15b', component.options)
    } else {
      api.reload('71a2f15b', component.options)
    }
    module.hot.accept("./FreeGiftLineItem.vue?vue&type=template&id=71a2f15b&", function () {
      api.rerender('71a2f15b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/FlyoutCart/FreeGiftLineItem.vue"
export default component.exports